/* angular:styles/component:css;8a703f5188d6a73981abcbe60c7b7d21f5eb067c3bf50c141a4c25729f5bf226;/src/src/app/shared/components/footer/footer.ts */
:host[data-isSmartPhone=true] {
  position: relative;
}
:host[data-isSmartPhone=false] {
  position: sticky;
  bottom: 0;
  width: 100%;
  font-size: 14px !important;
}
:host[data-isSmartPhone=false] :is(ion-row) {
  text-align: center;
}
:host[data-isSmartPhone=false] :is(ion-item) {
  font-size: inherit;
}
/*# sourceMappingURL=footer.css.map */
